const linkItems = {
  forwarder: [
    ['/', 'Manage Pick Ups'],
    ['/my-exports', 'Manage Drop Offs'],
    ['/my-pick-up-orders', 'My Pick Up Orders'],
    ['/my-drop-off-orders', 'My Drop Off Orders'],
    ['/payment-options', 'Payment Options'],
    ['/report-payment', 'Payment Report'],
    // ['/manage-users', 'Manage Users'],
    // ['/my-reports', 'My Reports']
  ],
  fwdAdmin: [
    ['/', 'Users Management']
  ],
  ghaOffice: [
    ['/dashboard', 'Dashboard'],
    ['/manage-imports', 'Manage Pick Ups'],
    ['/manage-exports', 'Manage Drop Offs'],
    ['/my-go-orders', 'GO Orders'],
    ['/awb-info', 'AWB Info'],
    ['/screening-report', 'Screening Report'],
    ['/shipment-inventory', 'Shipment Inventory'],
    ['/manage-rfs', 'Manage RFS'],
    ['/create-rfs/', 'Create RFS'],
    ['/tapa', 'TAPA']
  ],
  ghaWhs: [
    ['/whs-dashboard', 'Dashboard'],
    ['/dock-activity', 'Dock Activity'],
    ['/whs/order-awb-search', 'Order AWB Search'],
    ['/tapa', 'TAPA']
  ],
  ghaAdmin: [
    ['/', 'Payment Report'],
    ['/analytics', 'Analytics'],
    ['/user-management', 'Users Management'],
    ['/fwd-accounts', 'Forwarder Accounts']
    // ['/balance-report', 'Balance Report'],
    // ['/tsa-reg-list-upload', 'TSA Rеg List Upload']
  ],
  ghaSupervisor: [
    ['/analytics', 'Analytics'],
    ['/dashboard', 'Dashboard'],
    ['/manage-imports', 'Manage Pick Ups'],
    ['/manage-exports', 'Manage Drop Offs'],
    ['/my-go-orders', 'GO Orders'],
    ['/awb-info', 'AWB Info'],
    ['/dock-activity', 'Dock Activity'],
    ['/whs/order-awb-search', 'Order AWB Search'],
    ['/screening', 'Screening'],
    ['/screening-report', 'Screening Report'],
    ['/shipment-inventory', 'Shipment Inventory'],
    ['/manage-rfs', 'Manage RFS'],
    ['/create-rfs/', 'Create RFS'],
    ['/tapa', 'TAPA']
  ],
  laxOfficeAgent: [
    ['/dashboard', 'Dashboard'],
    ['/manage-imports', 'Manage Pick Ups'],
    ['/manage-exports', 'Manage Drop Offs'],
    ['/my-go-orders', 'GO Orders'],
    ['/awb-info', 'AWB Info'],
    ['/whs/order-awb-search', 'Order AWB Search'],
    ['/screening', 'Screening'],
    ['/screening-report', 'Screening Report'],
    ['/shipment-inventory', 'Shipment Inventory'],
    ['/manage-rfs', 'Manage RFS'],
    ['/create-rfs/', 'Create RFS'],
    ['/tapa', 'TAPA']
  ],
  ghaManager: [
    ['/analytics', 'Analytics'],
    ['/dashboard', 'Dashboard'],
    ['/manage-imports', 'Manage Pick Ups'],
    ['/manage-exports', 'Manage Drop Offs'],
    ['/my-go-orders', 'GO Orders'],
    ['/driver-queue-list', 'Driver Waiting List'],
    ['/payment-report', 'Payment Report'],
    ['/awb-info', 'AWB Info'],
    ['/dock-activity', 'Dock Activity'],
    ['/whs/order-awb-search', 'Order AWB Search'],
    ['/screening', 'Screening'],
    ['/screening-report', 'Screening Report'],
    ['/shipment-inventory', 'Shipment Inventory'],
    ['/user-management', 'Users Management'],
    ['/manage-rfs', 'Manage RFS'],
    ['/create-rfs/', 'Create RFS'],
    ['/tapa', 'TAPA']
    // ['/balance-report', 'Balance Report'],
    // ['/tsa-reg-list-upload', 'TSA Rеg List Upload']
  ],
  ghaSupervisorWh: [
    ['/whs-dashboard', 'Dashboard'],
    ['/awb-info', 'AWB Info'],
    ['/dock-activity', 'Dock Activity'],
    ['/whs/order-awb-search', 'Order AWB Search'],
    ['/screening', 'Screening'],
    ['/screening-report', 'Screening Report'],
    ['/shipment-inventory', 'Shipment Inventory'],
    ['/tapa', 'TAPA']
  ],
  superUser: [
    ['/dashboard', 'Dashboard'],
    ['/manage-imports', 'Manage Imports'],
    ['/manage-exports', 'Manage Exports'],
    ['/my-go-orders', 'GO Orders'],
    ['/driver-queue-list', 'Driver Waiting List'],
    ['/payment-report', 'Payment Report'],
    ['/awb-info', 'AWB Info'],
    ['/dock-activity', 'Dock Activity'],
    ['/whs/order-awb-search', 'Order AWB Search'],
    ['/screening', 'Screening'],
    ['/screening-report', 'Screening Report'],
    ['/shipment-inventory', 'Shipment Inventory'],
    ['/user-management', 'Users Management'],
    ['/manage-rfs', 'Manage RFS'],
    ['/create-rfs/', 'Create RFS'],
    ['/fwd-accounts', 'Forwarder Accounts'],
    ['/tapa', 'TAPA']
    // ['/balance-report', 'Balance Report'],
    // ['/tsa-reg-list-upload', 'TSA Rеg List Upload']
  ],
  ghaManagerWh: [
    ['/dashboard', 'Dashboard / Waiting List'],
    ['/awb-info', 'AWB Info'],
    ['/dock-activity', 'Dock Activity'],
    ['/whs/order-awb-search', 'Order AWB Search'],
    ['/screening', 'Screening'],
    ['/screening-report', 'Screening Report'],
    ['/shipment-inventory', 'Shipment Inventory'],
    ['/user-management', 'Users Management'],
    ['/tapa', 'TAPA']
  ],
  ghaAccounting: [
    ['/', 'Payment Report'],
    ['/awb-info', 'AWB Info'],
    ['/screening-report', 'Screening Report'],
    ['/shipment-inventory', 'Shipment Inventory'],
    ['/fwd-accounts', 'Forwarder Accounts']
    // ['/balance-report', 'Balance Report']
  ],
  ghaAccReco: [
    ['/', 'Payment Report']
  ],
  ghaScreener: [
    ['/', 'Screening'],
    ['/screening-report', 'Screening Report']
  ],
  ghaWarehouseScreener: [
    ['/whs-dashboard', 'Dashboard'],
    ['/dock-activity', 'Dock Activity'],
    ['/whs/order-awb-search', 'Order AWB Search'],
    ['/screening', 'Screening'],
    ['/screening-report', 'Screening Report'],
    ['/tapa', 'TAPA']
  ],
  ghaDashboard: [
    ['/dashboard', 'Dashboard / Waiting List'],
  ],
  ghaAirlineRepresentative: [
    ['/', 'Shipment Inventory'],
    ['/analytics', 'Analytics'],
    ['/screening-report', 'Screening Report']
  ],
  ghaOfflineRFSRep: [
    ['/manage-rfs', 'Manage RFS'],
    ['/create-rfs/', 'Create RFS']
  ],
};

export default {
  linkItems
}